export default "__VITE_ASSET__729e78b0__"